<template lang="pug">
  section#result
    .section__content
      .section__row
        .section__cell
          .caption
            h2.caption__text.text-hide 職涯格局緊來造
            .characters
              .character
          //- .image
          //-   a.visible-desktop(:href="require(`@/assets/images/result/q1-a.png`)" target="_blank" @click="clickImage")
          //-     img(:src="require(`@/assets/images/result/q1-a.png`)")
          //-   a.visible-tablet(:href="require(`@/assets/images/result/q1-a.jpg`)" target="_blank" @click="clickImage")
          //-     img(:src="require(`@/assets/images/result/q1-a.jpg`)")
          .image(v-if="result")
            //- a(:href="require(`@/assets/images/result/${result}.png`)" target="_blank" @click="clickImage")
            img.visible-desktop(:src="require(`@/assets/images/result/${result}.png`)")
            a.visible-tablet(:href="require(`@/assets/images/result/${result}.jpg`)" target="_blank" @click="clickImage")
              img(:src="require(`@/assets/images/result/${result}.jpg`)")
        .section__cell
          .display
            .display__row(v-show="!isLearnMore")
              .share
                .share__text
                  p.mobile 長按儲存圖片分享至IG#[br.visible-tablet]#[span]或點擊邀請好友一起測
                  p.dekstop 按右鍵另存我的職涯格局分析圖#[br]或分享至 FB 或 LINE 邀請好友來測
                ul.share__buttons.buttons
                  li
                    a#share_to_facebook.share__button-facebook.share__button.button(:href="`https://www.facebook.com/sharer/sharer.php?u=${url}`" target="_blank" @click="clickShare('fb')") 分享至 Facebook
                  li
                    a#share_to_line.share__button-line.share__button.button(:href="`https://social-plugins.line.me/lineit/share?url=${encodeURIComponent(url)}`" target="_blank" @click="clickShare('line')") 分享至 LINE
              ul.action__buttons.buttons
                li
                  a#play_again.action__button.button(href="#" @click.prevent="playAgain") 再玩一次
            .display__row(v-show="isLearnMore")
              ul.recruit__buttons.buttons
                li
                  //- a.recruit__button.button(href="#" @click.prevent="setPopup({type: 'recruitment', position: 'sales'})") #[span 業務菁英人才]
                  a.recruit__button.button(href="https://hr.sinyi.com.tw/elite" target="_blank" @click="clickLearnMore('sales')") #[span 業務菁英人才]
                li
                  //- a.recruit__button.button(href="#" @click.prevent="setPopup({type: 'recruitment', position: 'tech'})") #[span 數位科技人才]
                  a.recruit__button.button(href="https://hr.sinyi.com.tw/proptech/" target="_blank" @click="clickLearnMore('tech')") #[span 數位科技人才]
          //- ul.more__buttons.buttons
          //-   li
          //-     a#know_the_job.more__button.button(:class="{'more__button--opened': isLearnMore}" href="#" @click.prevent="toggleDisplay") #[span 了解職缺]
    .tips
      .tips__text
        p 下滑透視格局分析
      .tips__arrow
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'Result',
  props: {
  },
  data: () => {
    return {
      isLearnMore: false,
    }
  },
  computed: {
    ...mapState(['result']),
    url() {
      const { origin, pathname } = window.location;
      let shareName = 'share_c';
      if (this.result.indexOf('-c') === -1) { shareName = this.result.replace('q', 'share_'); }
      return `${origin}${pathname ? pathname : '/'}${shareName}.html`;
    },
  },
  methods: {
    ...mapMutations(['setPopup', 'resetQuizzes', 'setPage']),
    toggleDisplay() {
      this.isLearnMore = !this.isLearnMore;
      if (this.isLearnMore) {
        this.$trackEvent('result_position', 'click', 'result_position');
      }
    },
    playAgain() {
      const { resetQuizzes, setPage } = this;
      resetQuizzes();
      setPage('Quiz');
      // this.audioPlayer.pause();
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
      this.$trackEvent('result_again', 'click', 'result_again');
    },
    clickImage() {
      this.$trackEvent('result_photo', 'click', 'result_photo');
    },
    clickLearnMore(position) {
      this.$trackEvent('result_position', 'click', `result_position_${position}`);
    },
    clickShare(label) {
      this.$trackEvent('result_sharing', 'click', `result_sharing_${label}`);
    }
  },
  components: {
  }
}
</script>

<style lang="scss">

$assets: '~@/assets/images/result/';
$ratio: 0.8;

#result {

  padding-bottom: vwXL(60 * $ratio);
  background: url($assets + 'extra_desktop.png') center top no-repeat;
  background-size: vwXL(2400 * $ratio) vwXL(970 * $ratio);

  @include tablet {
    padding-bottom: 0;
    background: url($assets + 'extra.png') right top no-repeat;
    background-size: vw(453) vw(237);
  }

  @at-root #main #result { min-height: 0; }
  
  .dekstop {
    display: block;
    @include tablet {
      display: none;
    }
  }

  .mobile {
    display: none;
    @include tablet {
      display: block;
    }
  }

  .tips {
    display: flex;
    align-items: center;
    flex-direction: column;
    position: absolute;
    top: vwXL(620 * $ratio);
    right: vwXL(52 * $ratio);
    @include tablet {
      display: none;
    }
    p {
      color: #77b79e;
      font-size: vwXL(30 * $ratio);
      letter-spacing: vwXL(PsdLetterSpacing(240, 30) * $ratio);
      writing-mode: vertical-lr;
    }
    &::after {
      content: '';
      width: vwXL(46 * $ratio);
      height: vwXL(20 * $ratio);
      margin-top: vwXL(13 * $ratio);
      background: url($assets + 'tips-arrow.png') 0 0 no-repeat;
      background-size: vwXL(46 * $ratio) vwXL(20 * $ratio);
      animation: 2s tipsArrow ease-in-out infinite;
    }
  }

  .section__content {
    // display: flex;
    // justify-content: space-between;
    // flex-wrap: wrap;
    // padding-top: 105px;
    // padding-right: 48px;
    // padding-bottom: 83px;
    // padding-left: 48px;
    // background: url($assets + 'extra.png') right top no-repeat;
    // background-size: 453px 237px;
    width: vwXL(1112 * $ratio);
    margin: 0 auto;
    padding-top: vwXL(91 * $ratio);
    @include tablet {
      width: auto;
      margin: 0;
      padding-top: vw(105);
      padding-right: vw(48);
      padding-bottom: vw(60);
      padding-left: vw(48);
    }
  }

  .section__row {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    // height: auto;
    // height: vwXL(457);
    @include tablet {
      // height: auto;
      // flex-direction: column;
    }
  }

  .section__cell {
    position: relative;
    // width: 100%;
    @include tablet {
      position: static;
    }
    &:nth-child(1) {
      // width: vwXL(699);
      @include tablet {
        // width: auto;
      }
    }
    &:nth-child(2) {
      // width: vwXL(730);
      overflow: hidden;
      @include tablet {
        // width: auto;
      }
    }
  }

  .caption {
    width: vwXL(707 * $ratio);
    height: vwXL(120 * $ratio);
    margin-left: auto;
    background: url($assets + 'caption_desktop.png') 0 0 no-repeat;
    background-size: vwXL(707 * $ratio) vwXL(120 * $ratio);
    @include tablet {
      width: vw(440);
      height: vw(189);
      // margin-right: vw(-4);
      // margin-left: auto;
      background: url($assets + 'caption.png') 0 0 no-repeat;
      background-size: vw(440) vw(189);
    }
  }

  .image {
    position: relative;
    width: 100%;
    // max-width: 654px;
    height: auto;
    margin: 0 auto vwXL(20 * $ratio);
    background: #606060;
    @include tablet {
      width: 100%;
      max-width: vw(654);
      height: vw(676);
      margin: 0 auto vw(23);
      // background: #606060;
    }
    img {
      // display: none;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .display {
    flex-basis: 100%;
    &__row {
      display: flex;
      justify-content: space-between;
      // flex-wrap: wrap;
      // box-sizing: content-box;
      // height: vwXL(77);
      @include tablet {
        height: vw(71);
      }
      &:nth-child(1) {
        padding-top: 0;
        @include desktop {
          // display: block!important;
        }
        @include tablet {
          padding-top: vw(4);
        }
      }
    }
  }

  .share {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-direction: row-reverse;
    width: 100%;
    height: vwXL(118 * $ratio);
    @include tablet {
      // padding-right: vw(42);
      justify-content: center;
      width: auto;
      height: auto;
      flex-direction: row;
    }
  }

  .share__text {
    width: vwXL(550 * $ratio);
    color: #008536;
    font-size: vwXL(34 * $ratio);
    font-weight: 500;
    line-height: lineHeight(34, 48);
    letter-spacing: vwXL(PsdLetterSpacing(50, 34) * $ratio);
    padding-left: 0;
    padding-bottom: 0;

    white-space: nowrap;
    @include tablet {
      width: vw(260);
      font-size: vw(24);
      // font-weight: 600;
      line-height: lineHeight(24, 33.93);
      letter-spacing: vw(PsdLetterSpacing(120, 24));
      padding-left: vw(0);
      padding-bottom: vw(0);
      white-space: normal
    }
    p {
      white-space: nowrap;
      transform-origin: left center;
      transform: scaleX(0.95);
      @include tablet {
        transform: scaleX(0.92);
      }
    }
    span {
      display: inline-block;
      width: .5em;
      @include tablet {
        display: none;
      }
    }
  }

  .share__buttons {
    display: flex;
    padding-right: vwXL(15 * $ratio);
    @include tablet {
      margin-top: vw(-2);
      padding-right: 0;
    }
    li {
      margin-left: vwXL(30 * $ratio);
      @include tablet {
        margin-left: vw(12);
      }
      &:nth-child(1) {
        margin-left: 0;
        @include tablet {
          margin-left: vw(0);
        }
      }
    }
    .share__button {
      font-size: 0;
      text-indent: -50000px;
      background-repeat: no-repeat;

      width: vwXL(75 * $ratio);
      height: vwXL(79 * $ratio);
      background-image: url($assets + 'share-buttons_desktop.png');
      background-size: vwXL(180 * $ratio) vwXL(79 * $ratio);

      @include tablet {
        width: vw(56);
        height: vw(58);
        background-image: url($assets + 'share-buttons.png');
        background-size: vw(132) vw(58);
      }
      &-line {
        background-position: right top;
      }
    }
  }

  // 按鈕群
  .action__buttons {

    .action__button {
      width: vwXL(358 * $ratio);
      height: vwXL(98 * $ratio);
      font-size: vwXL(48 * $ratio);
      text-indent: vwX(PsdLetterSpacing(220, 48) * $ratio);
      letter-spacing: vwX(PsdLetterSpacing(220, 48) * $ratio);
      margin-top: vwXL(4 * $ratio);
      margin-bottom: vwXL(0 * $ratio);
      background-image: url($assets + 'action-buttons.png');
      background-size: vwXL(358 * $ratio) vwXL(98 * $ratio);
      @include tablet {
        width: vw(253);
        height: vw(56);
        font-size: vw(28);
        text-indent: vw(PsdLetterSpacing(340, 28));
        letter-spacing: vw(PsdLetterSpacing(340, 28));
        margin-top: vw(4);
        margin-bottom: 0;
        background-image: url($assets + 'action-buttons.png');
        background-size: vw(253) vw(56);
      }
    }

  }

  .recruit__buttons {

    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-basis: 100%;

    .button {

      width: vwXL(340);
      height: vwXL(74);
      color: #ffffff;
      font-size: vwXL(40);
      text-indent: vwXL(PsdLetterSpacing(200, 40));
      letter-spacing: vwXL(PsdLetterSpacing(200, 40));
      background-image: url($assets + 'recruit-buttons_desktop.png');
      background-position: 0 0;
      background-repeat: no-repeat;
      background-size: vwXL(728) vwXL(74);

      @include tablet {
        width: vw(303);
        height: vw(65);
        // color: #ffffff;
        font-size: vw(35);
        text-indent: vw(PsdLetterSpacing(200, 35));
        letter-spacing: vw(PsdLetterSpacing(200, 35));
        background-image: url($assets + 'recruit-buttons.png');
        // background-position: 0 0;
        // background-repeat: no-repeat;
        background-size: vw(655) vw(65);
      }

    }

    span {
      @include narrow-text;
      transform-origin: center center;
    }

    li:nth-child(2) .button {
      background-position: right 0;
    }

  }

  .more__buttons {

    flex-basis: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    // margin-top: 24px;
    @include tablet {
      position: static;
      margin-top: vw(24);
    }

    .more__button {
      width: vwXL(730);
      height: vwXL(134);
      color: #fefefe;
      font-size: vwXL(48);
      text-indent: vwXL(PsdLetterSpacing(200, 48));
      letter-spacing: vwXL(PsdLetterSpacing(200, 48));
      background: url($assets + 'more-buttons_desktop.png') 0 0 no-repeat;
      background-size: 100% auto;
      @include tablet {
        width: vw(655);
        height: vw(101);
        // color: #fefefe;
        font-size: vw(42);
        text-indent: vw(PsdLetterSpacing(200, 42));
        letter-spacing: vw(PsdLetterSpacing(200, 42));
        background: url($assets + 'more-buttons.png') 0 0 no-repeat;
        background-size: 100% auto;
        span {
          margin-bottom: .5px;
          @include narrow-text;
          transform-origin: center center;
        }
      }
      &--opened {
        color: #005323;
        background-position: 0 vwXL(-140);
        @include tablet {
          background-position: 0 vw(-104);
        }
      }
    }

  }

  // 人物群
  .characters {
    position: absolute;
    top: 0;
    left: 0;
  }

  // 柚子
  .character {
    position: absolute;
    top: vwXL(-63 * $ratio);
    left: vwXL(220 * $ratio);
    width: vwXL(152 * $ratio);
    height: vwXL(185 * $ratio);
    background: url($assets + 'character-body.png') 0 0 no-repeat;
    background-size: vwXL(152 * $ratio) vwXL(185 * $ratio);
    @include tablet {
      top: vw(110);
      left: vw(100);
      width: vw(152);
      height: vw(184);
      background-size: vw(152) vw(184);
    }
  }

}

</style>
